import { render, staticRenderFns } from "./StatisticalDataDashboard.vue?vue&type=template&id=25ceae06&"
import script from "./StatisticalDataDashboard.vue?vue&type=script&lang=js&"
export * from "./StatisticalDataDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports